var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-552.000000, -1533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.000000, 1533.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,7.5 L15,7.5 L15,9 L12.5,9 L12.5,14 L15,14 L15,18 L9,18 L9,14 L11.5,14 L11.5,9 L9,9 L9,7.5 L4.5,7.5 L4.5,14 L7,14 L7,18 L1,18 L1,14 L3.5,14 L3.5,6.5 L9,6.5 L9,5 L15,5 L15,6.5 L20.5,6.5 L20.5,14 L23,14 L23,18 L17,18 L17,14 L19.5,14 L19.5,7.5 Z",
    id: "Combined-Shape",
    fill: "#677283"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgChartIcon);
export default __webpack_public_path__ + "static/media/OrgChartIcon.440192bb988f43fbd04b64fed2c38bc0.svg";
export { ForwardRef as ReactComponent };